import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../context/authContext';
import { type AppRole, roleHasMinimum } from './routePermissions';

export default function RequireRouteAccess({
  minimumRole,
  children,
}: {
  minimumRole: AppRole;
  children: React.ReactNode;
}): ReactElement | React.ReactNode {
  const { user } = useAuth();

  if (!roleHasMinimum(user?.role, minimumRole)) {
    return <Navigate to='/' replace />;
  }

  return children;
}
